module.exports = "/images/homebuyers.png?dbfd0d2207e7d2aa45a696934273794e";